import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HealthGraphDataService {
  public graphdata = new BehaviorSubject<any>([]);
  constructor() {

   }
   setGraphData(data) {
     this.graphdata.next(data);
   }
   getGraphData() {
     return this.graphdata.asObservable();
   }
}
